import React from 'react';
import { computeRemSize } from '@ydistri/theme';
import { CalculationStatisticStoreSourceResponse } from '@ydistri/api-sdk';
import { useTableSourceStoreColumns } from '../columns/useTableSourceStoreColumns';
import { DataTable } from '@ydistri/ds';

interface PrefilledTableSourceStoreProps {
  data: CalculationStatisticStoreSourceResponse[] | undefined;
  displayDepartment?: boolean;
}

const PrefilledTableSourceStore: React.FC<PrefilledTableSourceStoreProps> = ({
  data,
  displayDepartment = false,
}) => {
  const columns = useTableSourceStoreColumns(displayDepartment);

  return (
    <DataTable<CalculationStatisticStoreSourceResponse>
      id="predefined-statistics-source-store-table"
      columns={columns}
      dataSource={data}
      size="small"
      height={computeRemSize(400)}
      showHeader
      showBorder
    />
  );
};

export default PrefilledTableSourceStore;
